// JsFromRoutes CacheKey d984283b34e4810a60e5be57525d9a48
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  get: definePathHelper('get', '(/:admin)/custom_clause_versions/export'),
  create: definePathHelper('post', '(/:admin)/custom_clause_versions/export')
}
